import * as _ from 'lodash-es';
import {Pair} from '../abstract-units';
import {Edge, Side} from '../edge';

export class SidedEdgesWalker {

    constructor(
        public sidedEdges: Pair<Edge[]>
    ) {}

    public isEmpty(): boolean {
        return !this.sidedEdges[Side.FIRST].length
            && !this.sidedEdges[Side.SECOND].length;
    }

    public firstSidedEdges(): Pair<Edge> {
        return [
            _.head(this.sidedEdges[Side.FIRST]),
            _.head(this.sidedEdges[Side.SECOND])
        ];
    }

    public lastSidedEdges(): Pair<Edge> {
        return [
            _.last(this.sidedEdges[Side.FIRST]),
            _.last(this.sidedEdges[Side.SECOND])
        ];
    }

    public unitedEdges(): Edge[] {
        return _.union(...this.sidedEdges);
    }

}
